import { object, string, number } from "yup";

const getValidationSchema = ({
  availableShares,
  allottedShares,
  sharesValue,
  isShareTransfer = false, // NEW: make schema conditional for transfer
}) => {
  const shape = {
    classOfShares: string().required("Class of shares is required"),
    allottedShares: number()
      .integer("Please enter a whole number")
      .min(1, "Must be greater than or equal to 1")
      .max(
        availableShares,
        typeof availableShares !== "undefined"
          ? `Value cannot be more than ${availableShares}`
          : ""
      )
      .required("Number of shares is required"),
  };

  // Only require these when NOT in share transfer mode
  if (!isShareTransfer) {
    shape.paidUpShares = number()
      .integer("Please enter a whole number")
      .min(0, "Must be greater than or equal to 0")
      .max(
        allottedShares,
        typeof allottedShares !== "undefined"
          ? `Value cannot be more than ${allottedShares}`
          : ""
      )
      .required("Number of shares fully paid up is required");

    shape.sharePrice = number()
      .required("Amount to be paid per share is required")
      .min(
        sharesValue,
        sharesValue ? `Value cannot be less than ${sharesValue}` : ""
      );
  }

  const schema = object().shape(shape);
  return { schema };
};

export default getValidationSchema;
